import React from 'react';
import FileDirectoryTree from './FileDirectoryTree';

export default function FileSelection(props) {
  const { files, toggleSelect, isTimelineEntry, isDiscrepancyEntry } = props;

  return (
    <>
      <div className="container-fluid overflow-auto" style={{ maxHeight: '100%' }}>
        <FileDirectoryTree
          files={files}
          toggleSelect={toggleSelect}
          isTimelineEntry={isTimelineEntry}
          isDiscrepancyEntry={isDiscrepancyEntry}
        />
      </div>
    </>
  );
}
